import { Component } from '@angular/core';
import { TeamReportServiceService } from '../../team-report/team-report-service.service';
import { OrgIndividualTeamsComponent } from '../../org-individual-teams/org-individual-teams.component';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../../../environments/environment';


@Component({
  selector: 'app-roster-edit-member-popup',
  templateUrl: './roster-edit-member-popup.component.html',
  styleUrls: ['./roster-edit-member-popup.component.scss']
})
export class RosterEditMemberPopupComponent {
  first_name: string;
  last_name: string;
  // phone: string;
  constructor(public teamReportService: TeamReportServiceService, public orgIndivTeams: OrgIndividualTeamsComponent, public http:HttpClient){
    this.first_name = this.orgIndivTeams.modalSvc.editRosterMemDetails.first_name;
    this.last_name = this.orgIndivTeams.modalSvc.editRosterMemDetails.last_name;
  }

  public close() {
    $('.roster_popup').css('display','none');
    $('.roster_mem_edit_popup').css('display','none');
    this.first_name = '';
    this.last_name = '';
    this.orgIndivTeams.modalSvc.editRosterMemDetails = null;
    // this.phone = '';
  }

  public addRosterMember() {
      var that = this;
      this.orgIndivTeams.loading = true;
      console.log("===>", this.orgIndivTeams.modalSvc.editRosterMemDetails)
      let data = {
        member_id: this.orgIndivTeams.modalSvc.editRosterMemDetails?.default_identity?.member_id,
        first_name: this.first_name,
        last_name: this.last_name,
        // phone: this.phone
      }
      console.log("editing user : ", data)
      if(this.orgIndivTeams.id == this.orgIndivTeams.demo_roster_id){
        this.orgIndivTeams.updateAcmeRosterTeamMemberFn(data)
        this.first_name = '';
        this.last_name = '';
        // this.phone = '';
      }else{
         this.http.post(`${environment.profileURL}/api/v1/roster_organizations/${this.orgIndivTeams.id}/update_member.json`,data).subscribe((res:any)=> {
        // this.orgIndivTeams.teamsData.members = res.memberships
        console.log(res.memberships)
        this.close()
        this.orgIndivTeams.roasterMembers();
        that.orgIndivTeams.loading = false;
        setTimeout(function () {
              this.toastr.options = {
                closeButton: true,
                progressBar: true,
                timeOut: 2000,
              };
              this.toastr.success(
                "Members Added Successfully!",
                "Nice!"
              );
        }, 1000);
        this.first_name = '';
        this.last_name = '';
        // this.phone = '';
      }, error=> {
        console.log(error)
        this.orgIndivTeams.loading = false;
        setTimeout(function () {
              this.toastr.options = {
                closeButton: true,
                progressBar: true,
                timeOut: 2000,
              };
              this.toastr.error(
                "Something went wrong!",
                "Oops!"
              );
            }, 1000);
      })
      }
     
    }
}